import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Context } from '../../context/Context';
import HeliosClient from '../../context/Helios';
import { ActionType, AppContext, DispatchFunction, Brands } from '../../context/interfaces';
import { logo, getCurrentLocation, expressService, headerLogo } from '../../context/Utils';
import { userSessionGTM } from 'shared/utils/gooogleTagManager';
import { BRAND, isActiveIntegrationCpe } from 'shared/utils';
import '../../assets/styles/screens/splash/Splash.scss';
import PATH_ROUTES from '../../static/constants/path-routes';
import useDevice from '../../hooks/useDevice';
import { encodeBase64 } from 'pendo/pendoUtils';
import CpeClient from 'context/CPE';

const TIME_TO_REDIRECT = 4000;

// TODO: Needs security.
export const fetchEventData = async (id: string, dispatch: DispatchFunction, context: AppContext): Promise<void> => {
	let data = await new HeliosClient().getInspection(id, context);
	localStorage.setItem('ClaimantType', data.ClaimantType);
	localStorage.setItem('ServiceId', data.serviceId);
	savePendoDataToStorage(data);

	//Validate if the inspection is sync with CPE
	if (data.eventId) {
		if (isActiveIntegrationCpe()) {
			const claim = await new CpeClient().getClaim(String(data.eventId));
			localStorage.setItem('cpeIsSync', claim?.length > 0 ? 'true' : 'false');

			if (!data.ClaimantType || String(data.ClaimantType).length === 0) {
				const claimantType = claim[0]?.appliesTo ? claim[0]?.appliesTo.toUpperCase() : data.ClaimantType;
				localStorage.setItem('ClaimantType', claimantType);
				data = { ...data, ClaimantType: claimantType };
			}

			if (!data.SinisterType || String(data.SinisterType).length === 0) {
				const sinisterType = claim[0]?.claimType ? claim[0]?.claimType : data.SinisterType;
				data = { ...data, SinisterType: sinisterType };
			}
		}
	}

	dispatch({ type: ActionType.SET_EVENT, data });
};

const savePendoDataToStorage = (data: AppContext): void => {
	const encryptedAccount = encodeBase64(String(data?.account));
	const encryptedCountryCode = encodeBase64(String(data?.countryCode));
	localStorage.setItem('account', encryptedAccount);
	localStorage.setItem('countryCode', encryptedCountryCode);
};

const SplashScreen = (): JSX.Element => {
	const context = useContext(Context) as AppContext;
	const history = useHistory();
	const { dispatch } = context;
	const { id } = useParams<{ id: string }>();
	const resultEnv = useDevice();
	const [loaderText, setLoaderText] = useState('Espere un momento...');

	const getEvent = (): void => {
		(async (): Promise<void> => {
			if (resultEnv.isDesktop) {
				history.push(PATH_ROUTES.PRE_ALERT_DEVICE_SCREEN);
			} else {
				if (id) {
					// Clear all local data when opening the event. Prevents rewriting data with information of other events
					localStorage.clear();
					localStorage.setItem('inspectionId', id);

					// Restore Photo Info Message
					context.dispatch({ type: ActionType.SET_SHOW_INFO_PHOTOS, data: { value: true } });

					getCurrentLocation();
					setTimeout(async () => {
						await fetchEventData(id, dispatch, context);
						setLoaderText('Cargando información...');
						setTimeout(() => {
							// Send Init Session to GT
							userSessionGTM(context);

							// TODO: Preferably we make sure data arrived before redirecting.
							if (
								BRAND === Brands.PREMIER ||
								BRAND === Brands.MULTINATIONAL ||
								BRAND === Brands.OPTIMA ||
								BRAND === Brands.SODA
							) {
								history.push('/' + id + '/photo/sections');
							} else {
								BRAND === Brands.CSM
									? history.push('/' + id + '/injured/information')
									: history.push('/' + id + '/insured/information');
							}
						}, TIME_TO_REDIRECT);
					}, 3000);
				}
			}
		})();
	};
	useEffect(getEvent, []);

	return (
		<div className="splash">
			{BRAND === Brands.CSM ? (
				<>
					<div className="header-logo">
						<img src={headerLogo} alt="header logo" />
					</div>
					<div className="main-info">
						<img className="logo" src={expressService} alt="CSM Servicio Express" />
					</div>
				</>
			) : (
				<>
					<div className="main-info">
						<img src={logo} alt="" className="logo" />
						<h3>Bienvenido a tu Inspector Virtual</h3>
						<p>{loaderText}</p>
					</div>
					{[
						Brands.LAFISE,
						Brands.OCEANICA,
						Brands.QUALITAS,
						Brands.SEGUROS_MUNDIAL,
						Brands.MULTINATIONAL,
						Brands.PREMIER,
						Brands.OPTIMA,
						Brands.COMFENALCO,
						Brands.SODA,
						Brands.PURDY,
						Brands.INS,
					].includes(BRAND as Brands) && (
						<p>
							Powered by <b>Connect Assistance</b>
						</p>
					)}
				</>
			)}
		</div>
	);
};

export default SplashScreen;
